import type { Brand } from '@/api/brands/type'
import styled from '@emotion/styled'
import { Flex, Text } from '@collable/ui'
import ManageVideoDetailSearchItem from './SearchItem'

interface ManageVideoDetailSearchResultProps {
  keyword: string
  brands: Brand[]
  onSelectBrand: (brand: Brand) => void
}

const ManageVideoDetailSearchResult = ({
  keyword,
  brands,
  onSelectBrand,
}: ManageVideoDetailSearchResultProps) => {
  const searchedBrandExist = !!brands.length

  const newBrandInfo = {
    brandId: 0,
    brandName: keyword,
    status: 'REQUEST',
    categoryCode: '',
    logoUrl: '',
  } as Brand

  return (
    <Container direction="column" gap={28}>
      <Flex direction="column" gap={8}>
        {brands.map(brand => (
          <button onClick={() => onSelectBrand(brand)} key={brand.brandId}>
            <ManageVideoDetailSearchItem brand={brand} />
          </button>
        ))}
      </Flex>
      <Flex direction="column" gap={16}>
        <Text size="body2" color="labelNeutral">
          {searchedBrandExist ? '찾는 브랜드가 없으신가요?' : '검색하신 브랜드가 없습니다.'}
        </Text>
        <button onClick={() => onSelectBrand(newBrandInfo)}>
          <ManageVideoDetailSearchItem brand={newBrandInfo} />
        </button>
      </Flex>
    </Container>
  )
}

export default ManageVideoDetailSearchResult

const Container = styled(Flex)`
  margin-top: 28px;
`
